import { useQuery } from "@tanstack/react-query";
import { Navigate, Outlet } from "@tanstack/react-router";

import { getBillingEntitlement, useCreditBilling } from "../lib/billing";
import { queryKeys } from "../lib/queryKeys";
import { InlineError, Skeleton } from "../ui";

// Resolve admission before the shell can mount queries or its SSE stream.
export function BillingCheckoutGate() {
  const capability = useCreditBilling();
  const entitlement = useQuery({
    enabled: capability.enabled,
    queryKey: queryKeys.billingEntitlement,
    queryFn: getBillingEntitlement,
    retry: false,
  });
  if (capability.isError) {
    return (
      <InlineError>Unable to load your account. Reload to retry.</InlineError>
    );
  }
  if (capability.isPending || (capability.enabled && entitlement.isPending)) {
    return (
      <Skeleton shape="detail-field" label="Loading your account" rows={4} />
    );
  }
  // A background refetch failure keeps the cached admission: the admitted
  // shell stays mounted (unsaved forms, SSE) instead of being torn down.
  if (capability.enabled && entitlement.isError && !entitlement.data) {
    return <InlineError>{entitlement.error.message}</InlineError>;
  }
  if (
    entitlement.data?.billing_state === "pending_billing" &&
    capability.enabled
  ) {
    return <Navigate replace to="/checkout" />;
  }
  return <Outlet />;
}
